var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMdiSortAscending = function SvgMdiSortAscending(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#313358",
    d: "M15.833 14.167h2.5L15 17.5l-3.333-3.333h2.5V2.5h1.666M1.667 14.167H10v1.666H1.667M5 4.167v1.666H1.667V4.167m0 5H7.5v1.666H1.667z"
  })));
};
export { SvgMdiSortAscending as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE1LjgzMzQgMTQuMTY2N0gxOC4zMzM0TDE1IDE3LjVMMTEuNjY2NyAxNC4xNjY3SDE0LjE2NjdWMi41SDE1LjgzMzRNMS42NjY2OSAxNC4xNjY3SDEwVjE1LjgzMzNIMS42NjY2OU01LjAwMDAyIDQuMTY2NjdWNS44MzMzM0gxLjY2NjY5VjQuMTY2NjdNMS42NjY2OSA5LjE2NjY3SDcuNTAwMDJWMTAuODMzM0gxLjY2NjY5VjkuMTY2NjdaIiBmaWxsPSIjMzEzMzU4Ii8+Cjwvc3ZnPgo=";